import { axiosClient } from "../shared/axiosInstance";

class MessageCaseService {
  constructor(token, dispatch) {
    this.token = token;
    this.dispatch = dispatch;
  }

  get_bug_types() {
    return axiosClient(this.dispatch, this.token).get(
      "/message-cases/bug-types?site=admin"
    );
  }

  get_all_bug_types() {
    return axiosClient(this.dispatch, this.token).get(
      "/message-cases/bug-types/all"
    );
  }

  update_bug_type(data) {
    if (!data) return null;
    return axiosClient(this.dispatch, this.token).put(
      "/message-cases/bug-types",
      data
    );
  }

  create_bug_type(data) {
    if (!data) return null;
    return axiosClient(this.dispatch, this.token).post(
      "/message-cases/bug-types",
      data
    );
  }

  create_message_case(data) {
    if (!data) return null;
    return axiosClient(this.dispatch, this.token).post("/message-cases", data);
  }

  update_message_case(id, data) {
    if (!data || !id) return null;
    return axiosClient(this.dispatch, this.token).patch(
      `/message-cases/${id}`,
      data
    );
  }

  get_case_by_id(id) {
    if (!id) return null;
    return axiosClient(this.dispatch, this.token).get(`/message-cases/${id}`);
  }

  get_user_cases() {
    return axiosClient(this.dispatch, this.token).get("/message-cases");
  }

  get_case_messages(id) {
    if (!id) return [];
    return axiosClient(this.dispatch, this.token).get(
      `/message-cases/${id}/messages`
    );
  }

  get_case_users(id) {
    if (!id) return [];
    return axiosClient(this.dispatch, this.token).get(
      `/message-cases/${id}/users`
    );
  }

  create_case_message(data) {
    if (!data) return null;
    return axiosClient(this.dispatch, this.token).post(
      "/message-cases/messages",
      data
    );
  }

  close_case(case_id) {
    if (!case_id) return null;
    return axiosClient(this.dispatch, this.token).patch(
      `/message-cases/${case_id}/close`
    );
  }

  create_case_user(case_id, user_id) {
    if (!case_id || !user_id) return null;
    return axiosClient(this.dispatch, this.token).post(
      `/message-cases/add-user`,
      { case_id, user_id }
    );
  }

  get_cases_by_type(type_id) {
    if (!type_id) return null;
    return axiosClient(this.dispatch, this.token).get(
      "/message-cases/by-bug-type?type=" + type_id
    );
  }

  accept_case(case_id) {
    if (!case_id) return null;
    return axiosClient(this.dispatch, this.token).post(
      "/message-cases/accept",
      { case_id }
    );
  }

  drop_case(case_id) {
    if (!case_id) return null;
    return axiosClient(this.dispatch, this.token).post("/message-cases/drop", {
      case_id,
    });
  }

  get_message_by_id(message_id) {
    if (!message_id) return null;
    return axiosClient(this.dispatch, this.token).get(
      `/message-cases/messages/${message_id}`
    );
  }

  get_bug_type(type_id) {
    if (!type_id) return null;
    return axiosClient(this.dispatch, this.token).get(
      `/message-cases/bug-types/${type_id}`
    );
  }
}

export default MessageCaseService;
